<template>
  <div class="contact-us full-screen">
    <div class="wrapper wrapper-full-page section content">
      <div class="">
        <div class="container">
          <div class="row">
            <div class="col-md-8 col-md-offset-2 text-center">
              <h2 class="title text-danger">{{ $t('page.notFound.title') }}</h2>
              <h2 class="title">{{ $t('page.notFound.description') }}</h2>
              <router-link to="Clubs">{{ $t('general.home') }}</router-link>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {}
</script>
